module.exports = __webpack_public_path__ + "static/img/16.07bcce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/16.jpg
// module id = ILTG
// module chunks = 1